var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "el-input", class: { "el-input--suffix": _vm.showSuffix } },
    [
      _c("input", {
        staticClass: "el-input__inner",
        class: { "is-disabled": _vm.disabled },
        attrs: {
          type: "type",
          placeholder: _vm.placeholder,
          name: _vm.name,
          disabled: _vm.disabled
        },
        domProps: { value: _vm.value },
        on: { input: _vm.handleinput }
      }),
      _vm._v(" "),
      _vm.showSuffix
        ? _c("span", { staticClass: "el-input__suffix" }, [
            _c("span", { staticClass: "el-input__suffix-inner" }, [
              _vm.clearable && _vm.value
                ? _c("i", {
                    staticClass:
                      "el-input__icon el-icon-circle-close el-input-clear",
                    on: { click: _vm.clear }
                  })
                : _vm._e()
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ee3a8a12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee3a8a12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/virtualTree/src/diyInput.vue
// module id = null
// module chunks = 